(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[167],{

/***/ 43065:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analyst",
      function () {
        return __webpack_require__(16826);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 58204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ analystLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/site/layout.tsx
var layout = __webpack_require__(31277);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox/dist/matchbox.esm.js + 50 modules
var matchbox_esm = __webpack_require__(18518);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox-icons/dist/matchbox-icons.esm.js
var matchbox_icons_esm = __webpack_require__(6848);
// EXTERNAL MODULE: ./hooks/useStatus.ts
var useStatus = __webpack_require__(381);
// EXTERNAL MODULE: ./components/site/baseNavigation.tsx
var baseNavigation = __webpack_require__(44177);
;// CONCATENATED MODULE: ./components/site/analystNavigation.tsx







var AnalystNavigation = function(props) {
    var _data = props.data, data = _data === void 0 ? [] : _data, title = props.title, titleLink = props.titleLink;
    var status = (0,useStatus/* default */.Z)().status;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(baseNavigation/* default */.ZP, {
        data: data,
        title: title,
        titleLink: titleLink,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
            py: "450",
            mt: "450",
            borderTop: "400",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "mailto:support@edatasource.com",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(baseNavigation/* StyledLink */.Fg, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
                            px: "500",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_icons_esm/* Feedback */.x2q, {
                                    size: 20
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    as: "span",
                                    pl: "300",
                                    children: "Submit a Ticket"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "https://api.edatasource.com/",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(baseNavigation/* StyledLink */.Fg, {
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
                            px: "500",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_icons_esm/* DeviceHub */.wNG, {
                                    size: 20
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    as: "span",
                                    pl: "300",
                                    children: "API Docs"
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                    href: "http://status.edatasource.com/",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(baseNavigation/* StyledLink */.Fg, {
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
                            px: "500",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    as: "span",
                                    display: "inline-block",
                                    width: "20px",
                                    height: "20px",
                                    verticalAlign: "middle",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                        width: "16px",
                                        height: "16px",
                                        backgroundColor: baseNavigation/* StatusColorMap */.zK[status],
                                        borderRadius: "50%"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                                    as: "span",
                                    pl: "300",
                                    children: "Service Status"
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var analystNavigation = (AnalystNavigation);

;// CONCATENATED MODULE: ./components/site/analystLayout.tsx



var AnalystLayout = function(props) {
    var children = props.children, navigationData = props.navigationData;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        hideDrawerButtons: true,
        navigationComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(analystNavigation, {
            data: navigationData,
            title: "Analyst Documentation",
            titleLink: "/analyst"
        }),
        children: children
    }));
};
/* harmony default export */ var analystLayout = (AnalystLayout);


/***/ }),

/***/ 16826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ analyst; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox-icons/dist/matchbox-icons.esm.js
var matchbox_icons_esm = __webpack_require__(6848);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./components/site/baseHomePageContent.tsx
var baseHomePageContent = __webpack_require__(70341);
;// CONCATENATED MODULE: ./components/site/analystHomePageContent.tsx





/* #Content */ var gettingStarted = {
    title: 'Getting Started',
    desc: 'Welcome to Analyst! Get familiar with our product and explore its features:',
    content: [
        {
            url: '/analyst/general/',
            title: 'General',
            desc: 'General platform definitions & common account-level inquiries',
            linkText: 'Learn More'
        },
        {
            url: '/analyst/inbox-and-design-tracker/',
            title: 'Inbox Tracker & Design Tracker',
            desc: 'A collection of How-To Guides',
            linkText: 'Learn More'
        },
        {
            url: '/analyst/competitive-tracker/',
            title: 'Competitive Tracker',
            desc: 'Guides for optimizing your use of Competitive Tracker',
            linkText: 'Learn More'
        },
        {
            url: '/analyst/sfmc/',
            title: 'Salesforce Marketing Cloud Integration',
            desc: 'A set of guides on the installation and integration of the Inbox Tracker application',
            linkText: 'Learn More'
        },
        {
            url: '/analyst/privacy-gdpr/',
            title: 'Privacy & GDPR',
            desc: 'We’re committed to keeping your private information private, your data protected and secure and being transparent about our practices',
            linkText: 'Learn More'
        },
        {
            url: 'https://api.edatasource.com/docs',
            title: 'API Docs',
            desc: 'Check out our full API reference.',
            linkText: 'View Documentation'
        }, 
    ]
};
var help = {
    title: "Questions? We're here to help.",
    desc: 'We’re always happy to help with code or other questions you might have!',
    desc2: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "To find the best resource for your question and fastest resolution, check out our",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(baseHomePageContent/* SimpleStyledLink */.s, {
                    $inlineBlock: true,
                    children: "how to get help guide"
                })
            })
        ]
    }),
    content: [
        {
            text: 'Submit a ticket',
            url: 'mailto:support@edatasource.com',
            Icon: matchbox_icons_esm/* Feedback */.x2q
        }, 
    ]
};
var AnalystHomePageContent = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(baseHomePageContent/* default */.Z, {
        gettingStarted: gettingStarted,
        help: help
    }));
};
/* harmony default export */ var analystHomePageContent = (AnalystHomePageContent);

// EXTERNAL MODULE: ./components/site/seo.tsx
var seo = __webpack_require__(51289);
// EXTERNAL MODULE: ./components/site/analystLayout.tsx + 1 modules
var analystLayout = __webpack_require__(58204);
// EXTERNAL MODULE: ./context/categories.tsx
var categories = __webpack_require__(18650);
;// CONCATENATED MODULE: ./pages/analyst/index.tsx





var IndexPage = function(props) {
    var categoryData = props.categoryData, navigationData = props.navigationData;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(categories/* CategoriesProvider */.z, {
        data: categoryData,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: "Analyst Documentation - SparkPost",
                description: "SparkPost Analyst Documentation"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(analystLayout/* default */.Z, {
                navigationData: navigationData,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(analystHomePageContent, {})
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var analyst = (IndexPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [398,371,221,774,888,179], function() { return __webpack_exec__(43065); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);